<style lang="scss">
  .sw-svelte-tooltip {
    display: contents;
  }
</style>

<script>
  import FloatingUI from "../utils/FloatingUI.svelte";

  export let placement;

  let referenceEl;

  let dismissed = false;
  let hovered = false;
  let focused = false;
  let timeout = null;
  const delayMs = 150;

  const withDelay = (f) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(f, delayMs);
  };

  const setTargetEl = (e) => {
    if (referenceEl) return;
    referenceEl = e.composedPath()[0] || e.target;
  };

  const onfocus = (e) => {
    dismissed = false;
    setTargetEl(e);
    withDelay(() => {
      focused = true;
    });
  };

  const onblur = (e) => {
    setTargetEl(e);
    withDelay(() => {
      focused = false;
    });
  };

  const onmouseenter = (e) => {
    dismissed = false;
    setTargetEl(e);
    withDelay(() => {
      hovered = true;
    });
  };

  const onmouseleave = (e) => {
    setTargetEl(e);
    withDelay(() => {
      hovered = false;
      focused = false;
    });
  };

  export const dismiss = () => {
    dismissed = true;
  };

  $: show = (focused || hovered) && !dismissed;
</script>

<div class="sw-svelte-tooltip">
  <slot {dismiss} {onfocus} {onblur} {onmouseenter} {onmouseleave} />
  {#if show}
    <FloatingUI
      {referenceEl}
      class="sw-svelte-tooltip"
      {placement}
      {onmouseenter}
      {onmouseleave}
    >
      <slot name="tooltip" />
    </FloatingUI>
  {/if}
</div>
